export const ENVIRONMENT = {
  LOCAL: 'local',
  DEV: 'dev27',
  DEPLOY: 'deploy',
  PROD: 'prod',
};

export const REPORT_LINK = {
  REPORT: 'report',
  REPORT_SEQUENCE: 'report-sequence',
  RESULTS: 'results',
  PROCESS_RESULTS: 'process-results',
};

export enum RespondentOriginator {
  IMPORT = 'IMPORT',
  AUTOGENERATED = 'AUTOGENERATED',
  ADMINISTRATOR = 'ADMINISTRATOR',
  TEAMIO = 'TEAMIO',
  AUTOMATIC_IMPORT = 'AUTOMATIC_IMPORT',
  API_IMPORT = 'API_IMPORT',
}

export enum ProductCode {
  Free = 'FREE',
  Business = 'BUSINESS',
  Preview = 'PREVIEW',
  Credits = 'CREDITS',
}
